import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const PDPGalleryLabelsUI = t0 => {
  const $ = _c(7);
  const {
    labels: t1,
    loading: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const labels = t3;
  const loading = t2 === undefined ? false : t2;
  let t4;
  if ($[2] !== labels || $[3] !== loading) {
    t4 = !loading && labels.map(_temp);
    $[2] = labels;
    $[3] = loading;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex">{t4}</div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
PDPGalleryLabelsUI.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool
};
export default PDPGalleryLabelsUI;
function _temp(label) {
  return <div className="text-xs font-bold items-center bg-yellow-light rounded text-gray flex justify-center h-[25px] ml-2 pl-3 pr-3 first:ml-0 w-max" key={label}>{label}</div>;
}